import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Sidebar.css';

function Sidebar({ user, onLogout }) {
  const location = useLocation();

  const isActive = (path) => location.pathname === path ? 'active' : '';

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <img src="/logo.png" alt="Clean Tec Outsourcing" className="sidebar-logo" />
        <p>{user?.email}</p>
        <span className="badge badge-primary">{user?.role}</span>
      </div>

      <nav className="sidebar-nav">
        <Link to="/" className={`nav-item ${isActive('/')}`}>
          Dashboard
        </Link>
        
        {user?.permissions?.view_positions && (
          <Link to="/positions" className={`nav-item ${isActive('/positions')}`}>
            Positions
          </Link>
        )}
        
        {user?.permissions?.view_applicants && (
          <>
            <div className="nav-section">Applicants</div>
            <Link to="/active" className={`nav-item ${isActive('/active')}`}>
              Active List
            </Link>
            <Link to="/hired" className={`nav-item ${isActive('/hired')}`}>
              Hired List
            </Link>
            <Link to="/released" className={`nav-item ${isActive('/released')}`}>
              Released List
            </Link>
            <Link to="/terminated" className={`nav-item ${isActive('/terminated')}`}>
              Terminated List
            </Link>
          </>
        )}
        
        {(user?.permissions?.view_metrics || user?.role === 'admin') && (
          <>
            <div className="nav-section">Admin & Analytics</div>
            {user?.permissions?.view_metrics && (
              <Link to="/metrics" className={`nav-item ${isActive('/metrics')}`}>
                Metrics
              </Link>
            )}
            {user?.role === 'admin' && (
              <Link to="/users" className={`nav-item ${isActive('/users')}`}>
                Users
              </Link>
            )}
          </>
        )}
      </nav>

      <div className="sidebar-footer">
        <button onClick={onLogout} className="btn btn-outline">
          Logout
        </button>
      </div>
    </div>
  );
}

export default Sidebar;
